import { useApiClient } from '@/api/client'
import { type CheckInModePinCode } from '../types.ts'

import { decamelizeKeys } from '@/functions/utils'

export const SETUP_PIN_CODE = '/core/v2/business_api/me/businesses/{businessId}/turntracker/settings/pin'

export const setupPinCode = (options: {
  businessId: number;
  payload: CheckInModePinCode;
}) => {
  const apiClient = useApiClient()

  return apiClient.post({
    url: SETUP_PIN_CODE,
    urlParams: {
      businessId: options.businessId,
    },
    data: decamelizeKeys(options.payload),
  })
}
